import React from 'react';

/* Base shimmer block */
const SkeletonBlock = ({ width = '100%', height = '1rem', style = {} }) => (
  <div
    className="skeleton"
    style={{ width, height, borderRadius: '4px', ...style }}
  />
);

/* ── Stat card (Dashboard) ──────────────────────────────────── */
export const SkeletonStatCard = () => (
  <div style={cardStyle}>
    <SkeletonBlock width="60%" height="0.875rem" />
    <SkeletonBlock width="40%" height="2.5rem" style={{ marginTop: '0.75rem' }} />
    <SkeletonBlock width="30%" height="0.75rem" style={{ marginTop: '0.75rem' }} />
  </div>
);

/* ── Table row (CandidateList) ──────────────────────────────── */
export const SkeletonTableRow = ({ cols = 6 }) => (
  <tr>
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} style={{ padding: '12px 16px' }}>
        <SkeletonBlock
          width={i === 0 ? '24px' : i === 1 ? '70%' : `${50 + Math.random() * 30}%`}
          height="0.875rem"
        />
      </td>
    ))}
  </tr>
);

/* ── Profile header (CandidateProfile) ─────────────────────── */
export const SkeletonProfile = () => (
  <div style={{ padding: '2rem' }}>
    {/* Header */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2rem' }}>
      <div style={{ flex: 1 }}>
        <SkeletonBlock width="40%" height="2rem" />
        <SkeletonBlock width="25%" height="1rem" style={{ marginTop: '0.5rem' }} />
        <SkeletonBlock width="20%" height="1.5rem" style={{ marginTop: '0.75rem', borderRadius: '999px' }} />
      </div>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <SkeletonBlock width="80px" height="36px" style={{ borderRadius: '6px' }} />
        <SkeletonBlock width="80px" height="36px" style={{ borderRadius: '6px' }} />
      </div>
    </div>

    {/* Tabs */}
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', borderBottom: '2px solid #e9ecef', paddingBottom: '0' }}>
      {[100, 90, 110, 80, 90].map((w, i) => (
        <SkeletonBlock key={i} width={`${w}px`} height="36px" style={{ borderRadius: '4px 4px 0 0' }} />
      ))}
    </div>

    {/* Content area */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i}>
          <SkeletonBlock width="35%" height="0.75rem" />
          <SkeletonBlock width="65%" height="1rem" style={{ marginTop: '0.35rem' }} />
        </div>
      ))}
    </div>
  </div>
);

/* ── Recent activity list item (Dashboard) ──────────────────── */
export const SkeletonListItem = () => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 0', borderBottom: '1px solid #f0f0f0' }}>
    <div style={{ flex: 1 }}>
      <SkeletonBlock width="40%" height="0.875rem" />
      <SkeletonBlock width="25%" height="0.75rem" style={{ marginTop: '0.35rem' }} />
    </div>
    <SkeletonBlock width="80px" height="0.75rem" />
  </div>
);

const cardStyle = {
  background: '#fff',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
  padding: '1.5rem',
};

export default SkeletonBlock;
